import {
    SET_CURRENT_USER,
    SET_MUTE,
    SET_AUTOASSIGN,
    SET_FULLSTORY,
    SET_LEAD_PROCESS_STATUS,
    SET_RELOAD_REPLY,
    SET_LIVE_LEAD_COUNT
} from '../actions/actionTypes';

const initialState = {
    isAuthenticated: false,
    user: {},
    isMute: false,
    isAutoAssignable: false,
    isFullStory: "hide",
    leadProcessStatus: "pending",
    reloadReply: false,
    liveLeadCount: 0,
}

const auth = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            const empty_check = (obj) => {
                return Object.keys(obj).length === 0;
            }
            return {
                isAuthenticated: !empty_check(action.user),
                user: action.user,
                isMute: state.isMute,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: state.isFullStory,
                leadProcessStatus: state.leadProcessStatus,
                reloadReply: state.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_MUTE:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: action.isMute,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: state.isFullStory,
                leadProcessStatus: state.leadProcessStatus,
                reloadReply: state.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_AUTOASSIGN:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: state.isMute,
                isAutoAssignable: action.isAutoAssignable,
                isFullStory: state.isFullStory,
                leadProcessStatus: state.leadProcessStatus,
                reloadReply: state.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_FULLSTORY:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: state.isMute,
                leadProcessStatus: state.leadProcessStatus,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: action.isFullStory,
                reloadReply: state.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_LEAD_PROCESS_STATUS:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: state.isMute,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: state.isFullStory,
                leadProcessStatus: action.leadProcessStatus,
                reloadReply: state.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_RELOAD_REPLY:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: state.isMute,
                leadProcessStatus: state.leadProcessStatus,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: state.isFullStory,
                reloadReply: action.reloadReply,
                liveLeadCount: state.liveLeadCount
            }
        case SET_LIVE_LEAD_COUNT:
            return {
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                isMute: state.isMute,
                leadProcessStatus: state.leadProcessStatus,
                isAutoAssignable: state.isAutoAssignable,
                isFullStory: state.isFullStory,
                reloadReply: state.reloadReply,
                liveLeadCount: action.liveLeadCount
            }
        default: return state;
    }
}

export default auth;